import React from "react";
import CountUp from "react-countup";

export default function CompanyProfileCounters({ company }) {
  return (
    <>
      <div className="companyCounters d-flex justify-content-center">
        <div className="companyCounter text-center me-3">
          <h6>
            <CountUp end={company?.contracts?.length} duration={5} />
          </h6>
          <p>العقود</p>
        </div>
        <div className="companyCounter text-center ms-3">
          <h6>
            <CountUp end={company?.branches?.length} duration={5} />
          </h6>
          <p>الفروع</p>
        </div>
      </div>
    </>
  );
}
